import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { store, history } from "./helpers";
import { App } from "./App";
import "./styles.css";

ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>,
  document.getElementById("root")
);
